import utils from "@/assets/js/utils.js";
// import context from '../main.js'
const urlParam = utils.getUrlParam(); //url里的参数
const host = ''; //配置ip及端口，默认为
const api = {
  buttonTab: host + "/bpm-server/api/components/configurations",
  submit: host + `/bpm-server/api/runtime/tasks/${utils.getUrlParam().taskId}/actions/submit`,
  back: host + `/bpm-server/api/runtime/tasks/${utils.getUrlParam().taskId}/actions/back`,
  save: host + `/bpm-server/api/runtime/process-instances/${utils.getUrlParam().instanceId}/actions/save`,
  cancel: host + `/bpm-server/api/runtime/tasks/${utils.getUrlParam().taskId}/actions/cancel`,
  check: host + `/bpm-server/api/runtime/tasks/${utils.getUrlParam().taskId}`,
  process: host + `/bpm-server/api/runtime/process-instances/${utils.getUrlParam().instanceId}/actions/start`,
  getBack: host + "/bpm-server/api/runtime/tasks/" + `{urlParam.taskId}` + "/activities", // 获取可驳回环节
  getTaskDetail: host + `/bpm-server/api/runtime/tasks/${utils.getUrlParam().taskId}`,

  processInfo: {
    //审批页面
    getSystemSave: host + "bpm-server/api/userdemo", //demo 保存
    getSystemSaveVariables: host + "/bpm-server/api/process-variables/", //demo 保存bpm关联
    getSystemId: host + "bpm-server/api/user-bind-workflow/systemid", //demo systemid
    getChangeSelect: host + "bpm-server/api/user-bind-workflow/definition", //demo 二级
    getFlowSelect: host + "bpm-server/api/user-bind-workflow/catalog", //demo 一级
    getyanshi: host + "bpm-server/api/user-bind-workflow", //demo
    getFlowPush: host + "bpm-server/api/user-bind-workflow/", //demo
    getApprovalInfo: host + "/bpm-server/api/process-view" + "?taskId=" + urlParam.taskId + "&componentType=0", //获取审批步骤
    getProcess: host + "/bpm-server/api/tasks/previous-activities/" + `{urlParam.taskId}`, //审批流程图
    //新的api
    upload: host + "/bpm-server/api/attachments/", //附件上传
    getUserInfo: host + "/bpm-server/api/user/", //获取用户信息接口
    getStatus: host + "/bpm-server/api/tasks/" + `{urlParam.taskId}`, // 获取当前状态
    getUcData: host + "/bpm-server/api/role-completion/uc-data/",
    getManagerData: host + "/bpm-server/api/role-completion/manager-data/",
    getInitiatorData: host + "/bpm-server/api/role-completion/initiator-data",
    roleAssignment: host + "/bpm-server/api/role-completion/role-assignment" // 为角色分配人员
  },
  approvalModal: {
    //提交审批和驳回
    submit: host + "/bpm-server/api/tasks/" + `{urlParam.taskId}`, //提交审批意见
    reject: host + "/bpm-server/api/tasks/" + `{urlParam.taskId}` //驳回审批
  },
  iframeForm2: {
    //获取业务组件页面
    getIframeUrl: host + "/bpm-server/api/tasks/" + `{urlParam.taskId}`
  },
  // save: {//暂存
  //     textSave: host + '/bpm-server/api/tasks/' + `{urlParam.taskId}`
  // },

  Urgent: host + "/bpm-server/api/tasks/urgent/" + `{urlParam.taskId}`, //催办
  Refuse: host + "/bpm-server/api/tasks/" + `{urlParam.taskId}`, //拒绝

  startProcess: {
    //发起流程页面
    newGetStartInfo: host + "/bpm-server/api/runtime/process-instances/{processInstId}/process-views", //获取发起流程页面的流程图和列表数据
    newGetInstance: host + `/bpm-server/api/runtime/tasks/${urlParam.taskId}`,

    getStartInfo: host + "/bpm-server/api/process-view/" + `{urlParam.instanceId}` + "?componentType=2", //获取发起流程页面的流程图和列表数据
    // new
    getInfoList: host + "/bpm-server/api/runtime/process-instances/" + `{urlParam.instanceId}` + "/process-views",

    hasProcess: host + "/bpm-server/api/process-view/select/" + `{urlParam.instanceId}`, //是否已经审批
    // start: host + '/bpm-server/api/process-instances/' + urlParam.number, //发起流程
    processInstances: host + "/bpm-server/api/process-instances/" + `{urlParam.instanceId}`, // 提交
    getIframeUrl: host + "/bpm-server/api/process-view/" + `{urlParam.instanceId}` + "?componentType=2"
  },
  addtabTree: {
    //加签
    getListByFlag: host + "/bpm-server/api/iam/org/getOrgListByBizCode", // 树导航
    getBySearchText: host + "/bpm-server/api/iam/user/getUserListBySearchText", // 搜索数据
    processPartPost: host + "/bpm-server/api/process-participants", // 保存已选人员
    processPartGet: host + "/bpm-server/api/process-participants", // 获取已有人员
    sysBizcode: host + "bpm-server/api/system/bizcode", // 获取维度
    plus: host + "bpm-server/api/process-participants/participantInfo",
    // 新加签确认
    addAction: host + "/bpm-server/api/runtime/process-instances/" + `{urlParam.instanceId}` + "/actions/assign-participants",
    countersign: host + `/bpm-server/api/process-participants-manager-record?processInstId=${urlParam.processInstId}`
  },
  taskcenter: {
    //个人中心
    getTodoInfo: host + "/bpm-server/api/pulltask/todo-task",
    getAlDoneInfo: host + "/bpm-server/api/pulltask/done-task",
    getInitiation: host + "/bpm-server/api/pullProcessInst/todoProcessInst",
    cancle: host + "/bpm-server/api/system/sso"
  },
  hasHandle: {
    getApprovalInfo: host + "/bpm-server/api/process-view" + "?taskId=" + urlParam.taskId + "&componentType=1" //获取审批步骤
  },
  myMaintainUrl: host + "/bpm-server/api/system-info/infos",
  delMaintainUrl: host + "/bpm-server/api/system-info/",
  addMaintainUrl: host + "/bpm-server/api/system-info",
  toDoRecords: host + "/bpm-server/api/push-todo/todo-records",
  pushToDo: host + "/bpm-server/api/push-todo", // 推送待办
  roleCompletionReportUrl:
    host + "/bpm-server/api/runtime/process-supplement/report",
  mqRecords: host + "/bpm-server/api/mq/records",
  pushMq: host + "bpm-server/api/mq/push", // 推送mq
  businessSystem: host + `/bpm-server/api/taskRemindConfig/querySystemList`, //查询业务系统
  getSystemTemplateList: host + `/bpm-server/api/taskRemindConfig/queryTemplateTaskRemindConfigList/`, //系统下面的模板详情
  taskRemindConfigSave: host + `/bpm-server/api/taskRemindConfig/save`, //系统下面的模板详情
  getSeachSystemList: host + `/bpm-server/api/taskRemindConfig/queryTemplateTaskRemindConfigListBySearch`,
  getParticipant: host + `/bpm-server/api/process-config/participant`,
  getRoleSupplyDetailed: host + `/bpm-server/api/runtime/process-role-supply/roleSupplyDetailed`, // 补人任务明细页面-按条件查询列表
  getRoleName: host + `/bpm-server/api/runtime/process-role-supply/roleSupplyDetailed/getRoleName`, // 补人任务明细页面-获取角色范围
  getOrgName: host + `/bpm-server/api/runtime/process-role-supply/roleSupplyDetailed/getOrgName`, // 补人任务明细页面-获取组织范围
  getMainCatalogName: host + `/bpm-server/api/runtime/process-role-supply/roleSupplyDetailed/getMainCatalogName`, // 补人任务明细页面-获取系统范围
  getMainProcessChName: host + `/bpm-server/api/runtime/process-role-supply/roleSupplyDetailed/getMainProcessChName`, // 补人任务明细页面-获取模板范围
  exportRoleSupplyDetailed: host + `/bpm-server/api/runtime/process-role-supply/exportRoleSupplyDetailed`, // 补人任务明细页面-导出
  // 内外网
  inextNetwork: host + `/bpm-server/api/inextNetwork`, // 判断内外网
  /*交o相关*/
  isHasGroup: host + `/bpm-server/api/intersect/`, // 查询是否创建群接口  method:get
  createOrJoinGroup: host + `/bpm-server/api/intersect/createOrJoin`, // 查询是否创建群接口 method: post
  headPictureBaseUrl: `https://img.longfor.com/headImg/small/`,
  getGroupRecord: host + `/bpm-server/api/intersect/getGroupRecord`,//获取交圈记录

};

export default api



// WEBPACK FOOTER //
// ./src/api/index.js